// extracted by mini-css-extract-plugin
module.exports = {"tint3":"_1uB5n7","tint4":"MHunjd","tint5":"_1IQE6n","base":"_5Dkot7"};